import React from "react";
import TextInput from './TextInput'
import TimeInput from './TimeInput'
import TextNumberInput from './TextNumberInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import InserimentoMultiploWidget from "./InserimentoMultiploWidget";
import Cookies from 'universal-cookie';
import GetInsegnanti from '../services/getInsegnanti';
import GetMaterie from '../services/getMaterie';
import GetAule from '../services/getAule';
import AddLezione from '../services/addLezione';
import getCorsi from '../services/getCorsi';
import getChiusura from '../services/getChiusura';
import getCorso from '../services/getCorso';
import moment from 'moment';
import Switch from 'react-switch';
import './css/style.css';
import addZoomMeeting from "../services/addZoomMeeting";
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class InsertMeetingWidget extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();
        this.selectBrokerRef = React.createRef();
        this.selectBreakRef = React.createRef();
        this.inserimentoMultiploWidget = React.createRef();

        this.subjectsRepresentative = [];
        this.valueRepresentative = [];
        
        this.subjects = [];
        this.state = {
            visible: false,
            selected: 'meeting',
            time: this.props.time, 
            isOnline: false,
            send: false,
            slots: 60,
            connectedToGoogle: false,
        }
    }

    async componentDidMount(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.insegnanti = await GetInsegnanti(username, token);
        this.materie = await GetMaterie(username, token);
        this.aule = await GetAule(username, token);
        this.corsi = await getCorsi(username, token);

        this.selectInsegnanti = [];
        this.selectMaterie = [];
        this.selectAule = [];
        this.selectCorsi = [];

        this.aule && this.aule.forEach(b => {
            this.selectAule.push({ value: b.id, label: b.nome.replace(/\\/g, '')});
        })

        this.insegnanti && this.insegnanti.forEach(b => {
            this.selectInsegnanti.push({ value: b.id, label: b.nome.replace(/\\/g, '') + ' ' + b.cognome.replace(/\\/g, '')});
        })

        this.corsi && this.corsi.forEach(b => {
            this.selectCorsi.push({ value: b.id, label: b.name.replace(/\\/g, '')});
        })

        if (this.props.subjectId == undefined) return;
        let scheduleType = this.props.scheduleType;
        this.subjects = [];

        this.setState({
            visible: this.props.visible,
            scheduleType: scheduleType,
            slots: 60,
            materia: undefined,
            aula: undefined,
            valueRepresentative: this.valueRepresentative,
            brokers: this.brokerSelected
        });
    }
    
    componentDidUpdate() {
        if (this.state.send) {
            this.createMeeting();
        }
    }

    render (){

        let st = Object.assign({minHeight: '600px', display: this.state.visible ? 'block' : 'none'})

        return ( 
        <div style={st}>
            <div style={container} onClick={() => { this.props.onDone(); this.setState({ visible: false }); }}>
                <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>
            <div style={{marginTop: '10px', display: this.state.selected == 'meeting' ? 'block' : 'none'}}>
                <div style={windowTitle}>{t('inserisci_lezione')}</div>
                
                <label style={{ marginTop: 10, marginLeft: 5 }}>
                    <span>{t('lez_online')} </span>
                    <Switch uncheckedIcon={false} checkedIcon={false} className="switch" width={40} height={20} onChange={(checked) => this.setState({ isOnline: checked })} checked={this.state.isOnline} />
                </label>
               
                <TextInput readOnly={true} name={t('data')} style={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }} value={this.props.date} />
                <TimeInput readOnly={true} name={t('orario')} inputStyle={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }} value={this.state.time} onChange={(val) => this.setState({time: val}) }/>

                <InserimentoMultiploWidget ref={this.inserimentoMultiploWidget} />

                <TextNumberInput name={t('durata')} value={this.state.slots} inputStyle={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }}
                    minValue="1" maxValue="600"
                    onChange={(val) => 
                        this.setState({slots : val,
                                    value: this.state.value})}/>

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.value} 
                    name={t('insegnante')} 
                    options={this.selectInsegnanti} 
                    onChange={(option) => {

                        if (this.state.value && option.value == this.state.value.value) return;
                        this.selectMaterie = [];
                        this.insegnanti && this.insegnanti.forEach(i => {
                            if (i.id != option.value) return;   
                            this.materie.forEach(m => {
                                if (m.id_insegnante != i.id) return;
                                this.selectMaterie.push({ value: m.id, label: m.materia.replace(/\\/g, '')});
                                }
                            )
                        })
                        this.setState({value: option, 
                            materia: undefined
                        })} 
                    }
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.altriInsegnanti} 
                    name={t('altri_insegnanti')} 
                    options={this.selectInsegnanti} 
                    isMulti={true}
                    onChange={(option) => {

                        this.setState({
                            altriInsegnanti: option
                        });
                    }}
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.materia} 
                    name={t('materia')} 
                    options={this.selectMaterie} 
                    onChange={(option) => 
                        this.setState({materia: option})} 
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.altriCorsi} 
                    name={t('altri_corsi')} 
                    options={this.selectCorsi} 
                    isMulti={true}
                    onChange={(option) => {

                        this.setState({
                            altriCorsi: option
                        });
                    }}
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.aula} 
                    name={t('aula')} 
                    options={this.selectAule} 
                    onChange={(option) => 
                        this.setState({aula: option})} 
                    />
                <br/>
                <FixButton title={t('salva')} callback={this.saveLesson.bind(this)} />
            </div>
                </div>
            </div>
        </div>
        )
    }



    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async saveLesson() {

        if (this.state.value == undefined || this.state.materia == undefined || this.state.slots < 15 || this.state.slots > 600) {
            Utils.showError(t('verifica_dati'));
            return;
        }

        var id_materia = this.state.materia.value;        
        this.selectedMateria = this.materie.filter((materia) => materia.id === id_materia);
        const durata = this.state.slots;
        
        const that = this;
        this.meetingLink = undefined;

        var altriInsegnanti = '';
        this.state.altriInsegnanti && this.state.altriInsegnanti.forEach(i => {
            altriInsegnanti += i.value + ';';
        })

        var altriCorsi = '';
        this.state.altriCorsi && this.state.altriCorsi.forEach(i => {
            altriCorsi += i.value + ';';
        })

        // Creazione meeting online
        if (this.state.isOnline) {
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            await addZoomMeeting(username, token, 'Lezione di ' + this.selectedMateria[0].materia, moment(this.props.date + ' ' + this.state.time, 'yyyy-MM-DD HH:mm').format('yyyy-MM-DDTHH:mm:ssZ'), durata, 'Lezione di ' + this.selectedMateria[0].materia + ' con: ' + this.state.value.label).then((res) => this.createMeeting(res.join_url, res.password, res.start_url));
        } else {
            await this.createMeeting('', '', '');
        }
    }

    async createMeeting(join_link, pwd, host_link) {
        
        if ((this.state.isOnline && join_link != undefined) || !this.state.isOnline ) {
            
            let is_online = this.state.isOnline ? 1 : 0;

            var id_insegnante = this.state.value.value;
            var id_materia = this.state.materia.value;
            var id_aula = this.state.aula ? this.state.aula.value : 0;

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            const id_corso = cookies.get('currentCourse', { path: '/' });
            this.chiusura = await getChiusura(username, token);
            this.corso = await getCorso(username, token, id_corso);
            
            this.selectedMateria = this.materie.filter((materia) => materia.id === id_materia);

            this.corsoDateEnd = moment(this.corso.dateEnd, "yyyy-MM-DD")

            const date = this.props.date;
            const hour = this.state.time.split(':')[0];
            const minutes = this.state.time.split(':')[1];
            const durata = this.state.slots;
            console.log(durata);

            const multiploValues = this.inserimentoMultiploWidget.current.getValues();
            
            var giorniDefiniti = false;
            multiploValues.giorniSettimana.forEach(g => {if (g == true)  giorniDefiniti = true});

            var altriInsegnanti = '';
            this.state.altriInsegnanti && this.state.altriInsegnanti.forEach(i => {
                altriInsegnanti += i.value + ';';
            })

            var altriCorsi = '';
            this.state.altriCorsi && this.state.altriCorsi.forEach(i => {
                altriCorsi += i.value + ';';
            })

            //inserimento singolo
            if (multiploValues.ripetizioni < 2 || giorniDefiniti == false){
                var res = await AddLezione(username, token, date, hour, minutes, durata, id_insegnante, altriInsegnanti, id_corso, altriCorsi, id_materia, id_aula, is_online, join_link, host_link, pwd);
                if (res.result === 'KO') {
                    if (res.description) alert (res.description);
                    else Utils.showError(t('errore_imprevisto'));
                } else {
                    this.props.onDone();  
                }
            }
            // inserimento multiplo
            else {
                var tempRipetizioni = multiploValues.ripetizioni;
                var momentDate = moment(date);
                var errorInsert = false;

                while (tempRipetizioni > 0){

                    var tempDate = moment(momentDate).format('yyyy-MM-DD');

                    var flagChiusura = false;
                    this.chiusura.forEach(c => {
                        var chiusura = moment(c.day, "DD-MM-yyyy HH:mm:ss").format('yyyy-MM-DD');
                        if (chiusura == tempDate) flagChiusura = true;
                    });

                    var altriInsegnanti = '';
                    this.state.altriInsegnanti && this.state.altriInsegnanti.forEach(i => {
                        altriInsegnanti += i.value + ';';
                    })

                    var altriCorsi = '';
                    this.state.altriCorsi && this.state.altriCorsi.forEach(i => {
                        altriCorsi += i.value + ';';
                    })

                    // se non è un giorno di chiusura provo ad inserire la lezione
                    if (flagChiusura == false) {
                        var res = await AddLezione(username, token, tempDate, hour, minutes, durata, id_insegnante, altriInsegnanti, id_corso, altriCorsi, id_materia, id_aula, is_online, join_link, host_link, pwd);
                        if (res.result == 'KO')
                        {
                            errorInsert = true;
                        } else {
                            tempRipetizioni--;
                        }
                    }
                    
                    momentDate.add(1, 'day');
                    var weekday = momentDate.weekday();

                    while (multiploValues.giorniSettimana[weekday] == false){
                        momentDate.add(1, 'day');
                        weekday = momentDate.weekday();
                    }

                    if (this.corsoDateEnd < momentDate) break;
                }

                if (errorInsert == true){
                    alert (t('errori_inserimento'));
                }
                if (tempRipetizioni > 0){
                    alert (t('inserite_solo') + String(multiploValues.ripetizioni - tempRipetizioni) + t('lez_anzi') + String(multiploValues.ripetizioni));
                }
                this.setState({ send: false });
                this.props.onDone();
            }

        }
    }

    handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        this.setState({value: value})
      };

}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    
    position: 'absolute',
    top: '90px',
    left: 'calc((100% - 365px)/2)', 
    height: '600px',
    background: 'white',
    padding: '2%', 
    width: '365px',
    minWidth: '360px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}